import React from 'react';
import { MdCheck } from 'react-icons/md';
import { Tooltip, Whisper } from 'rsuite';
import { NegotiationSupplierDatapointStatus } from '../../../NegociacaoFornecedor.types';
import styles from './ApprovedButton.module.scss';

export interface ApprovedButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  currentStatus?: NegotiationSupplierDatapointStatus;
}

export const ApprovedButton: React.FC<ApprovedButtonProps> = ({ onClick, disabled = false, className = '', currentStatus }) => {
  const isSelected = currentStatus === 'APPROVED';
  const isInactive = currentStatus === 'DECLINED';

  const buttonClass = isSelected
    ? `${styles['approved-button']} ${styles['approved-button--selected']} ${className}`
    : isInactive
      ? `${styles['approved-button']} ${styles['approved-button--inactive']} ${className}`
      : `${styles['approved-button']} ${className}`;

  const getIconColor = () => {
    if (isSelected) return '#ffffff'; // White when selected
    if (isInactive) return '#000000'; // Black when inactive
    return '#28a745'; // Green when default
  };

  return (
    <Whisper placement="left" trigger="hover" speaker={<Tooltip>Aprovar preço negociado</Tooltip>}>
      <button className={buttonClass} onClick={onClick} disabled={disabled} type="button">
        <MdCheck className={styles['approved-icon']} color={getIconColor()} />
      </button>
    </Whisper>
  );
};
